export default __webpack_public_path__ + "static/media/Newsletter 019.0a21eef9.png";